module.exports = __webpack_public_path__ + "img/wallet_card4.5b45872d.png";